'use strict';

$(window).on('init resize orientationchange', function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
        $('.fixed-brand-menu').slick({
            slidesToShow: 3,
            centerMode: false,
            arrows: false,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            dots: false,
            autoplay: false,
            variableWidth: true,
        });
    }
});

$('.brand-products-carousel').slick({
    slidesToShow: 4,
    centerMode: false,
    arrows: true,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            centerMode: false,
            arrows: true,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.3,
            centerMode: false,
            initialSlide: 0,
            arrows: true,
            swipe: true,
            infinite: false,
            dots: false
        }
    }]
});

$('.brand-pros-carousel').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: true,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            centerMode: false,
            arrows: true,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.3,
            centerMode: false,
            initialSlide: 0,
            arrows: true,
            swipe: true,
            infinite: false,
            dots: false
        }
    }]
});

$('.brandComponent-5 .single-item, .brandComponent-5 .navigation-item').on('init', function(){
    if($('.single-item .slick-prev').attr('aria-disabled')=="true" &&
    $('.navigation-item .slick-prev').attr('aria-disabled')=="true") {
        $('.slick-prev').addClass('disabled');
    }
    else {
        $('.slick-prev').removeClass('disabled');
    }
    
    if($('.single-item .slick-next').attr('aria-disabled')=="true" &&
    $('.navigation-item .slick-next').attr('aria-disabled')=="true") {
        $('.slick-next').addClass('disabled');
    }
    else {
        $('.slick-next').removeClass('disabled');
    }
}
);

$(".brandComponent-5 .single-item").slick({
    slidesToShow: 1,
    centerMode: false,
    accessibility: false,
    arrows: true,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    asNavFor: '.navigation-item',
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
});
$(".brandComponent-5 .navigation-item").slick({
    slidesToShow: 4,
    centerMode: false,
    accessibility: false,
    arrows: false,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    slidesToScroll: 1,
    asNavFor: '.single-item',
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
            arrows: false,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: false,
            dots: false
        }
    }]
});

$('.brandComponent-5 .single-item, .brandComponent-5 .navigation-item').on('afterChange', function(){
    if($('.single-item .slick-prev').attr('aria-disabled')=="true" && $('.navigation-item .slick-prev').attr('aria-disabled')=="true") {
        $('.slick-prev').addClass('disabled');
    }
    else {
        $('.slick-prev').removeClass('disabled');
    }
    
    if($('.single-item .slick-next').attr('aria-disabled')=="true" &&
    $('.navigation-item .slick-next').attr('aria-disabled')=="true") {
        $('.slick-next').addClass('disabled');
    }
    else {
        $('.slick-next').removeClass('disabled');
    }
});

$('.brand-lives-carousel').slick({
    slidesToShow: 4.3,
    centerMode: false,
    arrows: false,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 2.3,
            centerMode: false,
            arrows: false,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.3,
            centerMode: false,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: false,
            dots: false
        }
    }]
});

$(document).ready(function () {
    $('.start-one-to-one').click(function () {
        var $event = "talk_to_a_pro_click";
        var $cta_name = "Service Page";
        dataLayer.push({
            'event': $event,
            'site_location': $cta_name
        });
    });
});